import CheckoutPage from 'dispensary/checkout';
import { getPrivateDispensaryServerSideProps } from 'src/utils/ssr/get-dispensary-server-side-props';

export const getServerSideProps = getPrivateDispensaryServerSideProps;

export default CheckoutPage;
